import React from 'react';
import { PropTypes } from 'prop-types';

import PriceConceptsBreakdown from 'components/PriceConceptsBreakdown';
import { useTranslation } from 'react-i18next';

const getPriceConcepts = ({ extras, t }) => [
  ...extras.map((extra) => ({
    concept: t(`extraNames:${extra}`),
    tooltipInnerComponent: () => t(`extras.${extra}.tooltip`),
    conceptQuantity: false,
  })),
];

const PricingDetail = ({ className, extras }) => {
  const { t } = useTranslation('Quote');

  return (
    <div className={className}>
      <h3>{t('Recurring:detail.details')}</h3>
      <PriceConceptsBreakdown
        concepts={getPriceConcepts({ extras, t })}
        showTooltips
        showQuantity={false}
      />
      <p>{t('Recurring:detail.info-price')}</p>
    </div>
  );
};

PricingDetail.propTypes = {
  extras: PropTypes.arrayOf(PropTypes.string),
};

PricingDetail.defaultProps = {
  extras: [],
};

export default PricingDetail;
